import React, { Component } from 'react'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'
import ReCAPTCHA from 'react-google-recaptcha'
import { Form, Field } from 'redux-form'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'
import Button from 'components/common/Button/Button'
import { Input } from 'components/common/FormElements/Input'
import { H2 } from 'components/common/Text/Text'
import Columns from 'components/common/Columns/Columns'
import StoreAddressInput from './components/StoreAddressInput'
import { normalizePhoneNumber } from 'helpers/phone-number'
import { PHONE_MASK } from 'constant'
import { PERSONAL_INFORMATION, SERVICE_DETAILS, CONTACT_DETAILS, SERVICE_DETAILS_HINT, SERVICE_DETAILS_HINT_ID } from '../constants'

const { BOT_GOOGLE_RECAPTCHA_SITE_KEY } = (window.GLOBAL_VARS || process.env)

// TODO fix subject's field styling issues introducing by dropdown refactoring with react-select
const BOTContactUsForm = ({
  handleSubmit,
  formViewModel,
  normalizeValue,
  normalizeCommentField,
  handleSubjectSelect,
  storeLocationRequiredProp,
  captchaRef,
  reCaptchaErrorMessage
}) =>
  <Wrapper>
    <Title headline_narrow data-at-contact-us-form-title>Customer Contact Form</Title>
    <StyledForm data-at-contact-us-form onSubmit={ handleSubmit }>
      <StyledColumns adaptive width="50% 50%">
        <fieldset>
          <legend><Media.ScreenReader>{ PERSONAL_INFORMATION }</Media.ScreenReader></legend>
          <StyledField
            { ...formViewModel.contactSubject }
            normalize={ normalizeValue }
            component={ Input }
            onChange={ handleSubjectSelect } />
          <StyledField
            { ...formViewModel.name }
            component={ Input } />
          <StyledField
            { ...formViewModel.phone }
            mask={ PHONE_MASK }
            normalize={ normalizePhoneNumber }
            component={ Input } />
          <StyledField
            { ...formViewModel.email }
            component={ Input } />
          <StyledField
            { ...formViewModel.zipCode }
            component={ Input } />
        </fieldset>
        <fieldset>
          <legend><Media.ScreenReader>{ SERVICE_DETAILS }</Media.ScreenReader></legend>
          <StyledHint id={ SERVICE_DETAILS_HINT_ID }>{ SERVICE_DETAILS_HINT }</StyledHint>
          <StyledField
            { ...formViewModel.storeLocation }
            { ...storeLocationRequiredProp }
            component={ StoreAddressInput } />
          <StyledField
            { ...formViewModel.dateOfService }
            component={ Input } />
          <StyledField
            { ...formViewModel.invoiceOrEstimate }
            component={ Input } />
        </fieldset>
      </StyledColumns>
      <fieldset>
        <legend><Media.ScreenReader>{ CONTACT_DETAILS }</Media.ScreenReader></legend>
        <CommentField
          { ...formViewModel.comments }
          height="180px"
          normalize={ normalizeCommentField }
          component={ Input } />
      </fieldset>
      <ReCaptchaComponent
        reCaptchaErrorMessage={ reCaptchaErrorMessage }
        ref={ captchaRef }
        sitekey={ BOT_GOOGLE_RECAPTCHA_SITE_KEY }
        badge="bottomleft" />
      {reCaptchaErrorMessage && (
        <ReCaptchaErrorMessage>
          {reCaptchaErrorMessage}
        </ReCaptchaErrorMessage>
      )}
      <StyledButton
        data-at-submit-button
        narrow
        full="mobile">
        submit comments
      </StyledButton>
    </StyledForm>
  </Wrapper>

export default BOTContactUsForm

BOTContactUsForm.propTypes = {
  captchaRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Component) })
  ]),
  formatSubjectField: PropTypes.func,
  formViewModel: PropTypes.shape({
    contactSubject: PropTypes.shape(),
    formViewModel: PropTypes.shape(),
    name: PropTypes.shape(),
    phone: PropTypes.shape(),
    invoiceOrEstimate: PropTypes.shape(),
    comments: PropTypes.shape(),
    dateOfService: PropTypes.shape(),
    storeLocation: PropTypes.shape(),
    zipCode: PropTypes.shape(),
    email: PropTypes.shape()
  }),
  handleSubjectSelect: PropTypes.func,
  handleSubmit: PropTypes.func,
  normalizeCommentField: PropTypes.func,
  normalizeValue: PropTypes.func,
  reCaptchaErrorMessage: PropTypes.string,
  storeLocationRequiredProp: PropTypes.shape({})
}

const Wrapper = styled.div`
  margin: 0 auto 70px;
  ${Mixin.responsive('padding', '0', '0 20px')}
`

const StyledForm = styled(Form)`
  margin: 0 auto;
  ${Mixin.responsive('width', '620px', '100%')}
`

const StyledField = styled(Field)`
  width: 302px;
  margin-bottom: 30px;
  ${Media.mobile`
    display: block;
    width: 100%;
  `}
`

const StyledHint = styled(StyledField)`
  margin-bottom: 22px;
`.withComponent('div')

const CommentField = styled(StyledField)`
  width: 100%;
  margin-bottom: 45px;

  & [data-error-message] {
    top: 189px;
  }
`

const StyledColumns = styled(Columns)`
  [data-column] {
    ${Mixin.responsive('padding-right', '15px', '0')}
  }

  ${Media.mobile`
    & [data-error-message] {
      position: static;
      display: inline-block;
      margin-top: 7px;
    }
  `}
`

const Title = styled(H2)`
  margin: 0 0 20px;
  ${Mixin.font.GothamBold(26, 600)}
`

const StyledButton = styled(Button)`
  ${Media.desktop`
    float: right;
  `}
`

const ReCaptchaErrorMessage = styled.p`
  color: ${Theme.colors.red};
  margin-bottom: 65px;
`

const ReCaptchaComponent = styled(ReCAPTCHA)`
  margin-bottom: 80px;
  ${props => props.reCaptchaErrorMessage && css`
    margin-bottom: 10px;
  `}
`
